import React from 'react';
import { Modal, ModalBody } from 'react-bootstrap';
import './styles.scss';

type Props = {
	show: boolean,
	onHide: () => void,
	title?: string,
	children: React.Node,
	bsSize?: 'large' | 'small',
};

const InfoPopupModal = ({
	show,
	onHide,
	title,
	children,
	bsSize,
}: Props) => (
	<Modal
		show={show}
		onHide={onHide}
		bsSize={bsSize || 'large'}
		backdrop
		keyboard
		backdropClassName="info-popup-modal-backdrop"
		className="info-popup-modal-dialog"
	>
		<ModalBody
			className="info-popup-modal__body"
			style={{
				maxHeight: '80vh',
				overflowY: 'auto',
				paddingLeft: '30px',
				paddingRight: '30px',
				paddingTop: '16px',
				paddingBottom: '16px',
			}}
		>
			<button
				type="button"
				className="info-popup-modal__close"
				onClick={onHide}
				aria-label="Close"
			>
				<span aria-hidden="true">&times;</span>
			</button>
			<div className="info-popup-modal__inner">
				{title ? (
					<h4 className="info-popup-modal__title">{title}</h4>
				) : null}
				{children}
			</div>
		</ModalBody>
	</Modal>
);

export default InfoPopupModal;
